import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { axiosInstance } from '../..';
import { TCancelPaymentProps, TPayment } from '../../../types';

export const getPayments = createAsyncThunk<TPayment[]>('payments/get-all', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get<TPayment[]>('/payments');
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});

export const cancelPayment = createAsyncThunk<null, TCancelPaymentProps>('payments/cancel', async ({ id }, { rejectWithValue }) => {
  try {
    await axiosInstance.delete(`/payments/${id}`);

    return null;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});
